import { Map } from "immutable";
import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { PureComponent } from "react";

import FormButton from "../../components/form/FormButton";
import FormDropdown from "../../components/form/FormDropdown";
import ModalBody from "../../components/modal/ModalBody";
import ModalField from "../../components/modal/ModalField";
import ModalFooter from "../../components/modal/ModalFooter";
import ModalFooterRightGroup from "../../components/modal/ModalFooterRightGroup";
import ModalGroup from "../../components/modal/ModalGroup";
import ModalHeading from "../../components/modal/ModalHeading";
import ModalRow from "../../components/modal/ModalRow";
import ModalView from "../../components/modal/ModalView";
import PubSubTopics from "../../constants/pubSubTopics";
import { typeSelectors } from "../../modules/definition/types";

class SettingsConfirmDeleteActionModal extends PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      typeChanges: Map()
    };

    this.onDoneClick = this.onDoneClick.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onTypeOptionChanged = this.onTypeOptionChanged.bind(this);
  }

  componentDidMount() {
    this._pubSubEscapeKeyDownToken = PubSub.subscribe(PubSubTopics.escapeKeyDown, this.onCloseClick);
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this._pubSubEscapeKeyDownToken);
  }

  onDoneClick() {
    this.props.onDoneClick(this.state.typeChanges);
  }

  onCloseClick() {
    this.props.onCloseClick();
  }

  onTypeOptionChanged(deletedTypeId, actionId) {
    this.setState({
      typeChanges: this.state.typeChanges.set(deletedTypeId, actionId)
    });
  }

  renderTypePrompt(deletedType, options) {
    const value = this.state.typeChanges.has(deletedType.id) ? this.state.typeChanges.get(deletedType.id) : null;
    let shownOnlyInNarrative = false;
    let shownOnlyInMindmap = false;
    if (value) {
      const type = this.props.enabledTypes.find(t => t.id === value);
      shownOnlyInNarrative = typeSelectors.isNarrativeOnlyType(type);
      shownOnlyInMindmap = typeSelectors.isMindmapOnlyType(this.props.localStore, type);
    }

    return (
      <ModalRow key={deletedType.id}>
        <ModalField label={`${deletedType.label} Items`}>
          <FormDropdown
            options={options}
            value={value}
            onChange={val => this.onTypeOptionChanged(deletedType.id, val)}
          />
          <div className="warning">
            {shownOnlyInMindmap
              ? "Items not included on a Mindmap will be  deleted"
              : shownOnlyInNarrative
                ? "Items not included in the Narrative will be  deleted"
                : ""}
          </div>
        </ModalField>
      </ModalRow>
    );
  }

  render() {
    const actionOptions = this.props.enabledTypes
      .map(t => {
        return {
          label: `Convert to ${t.label}`,
          value: t.id
        };
      })
      .toList()
      .toArray();

    actionOptions.splice(0, 0, {
      label: "Delete Items",
      value: null
    });

    const actionRows = this.props.deletedTypes
      .map(t => this.renderTypePrompt(t, actionOptions))
      .toList()
      .toArray();

    const labelText = "How should we handle existing items for disabled item types?";
    let header = null;
    let footer = null;
    let groupLabel = null;

    //#!if iOS === true
// header = (
// <ModalHeading
// title="Disabled Type Confirmation"
// showBack={true}
// onBackClick={this.onCloseClick}
// showRightButton={true}
// rightButtonLabel={"Confirm"}
// onRightButtonClick={this.onDoneClick}
// />
// );
// groupLabel = labelText;
    //#!else
    header = <ModalHeading title={labelText} showCancel={false} />;
    footer = (
      <ModalFooter>
        <ModalFooterRightGroup>
          <FormButton primary={false} label="Cancel" onClick={this.onCloseClick} />
          <FormButton primary={true} label="OK" onClick={this.onDoneClick} />
        </ModalFooterRightGroup>
      </ModalFooter>
    );
    // #!endif

    return (
      <ModalView className="confirmation" header={header} footer={footer}>
        <ModalBody>
          <ModalGroup label={groupLabel}>{actionRows}</ModalGroup>
        </ModalBody>
      </ModalView>
    );
  }
}

SettingsConfirmDeleteActionModal.propTypes = {
  localStore: PropTypes.object.isRequired,
  enabledTypes: PropTypes.object.isRequired,
  deletedTypes: PropTypes.object.isRequired,
  onDoneClick: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired
};

export default SettingsConfirmDeleteActionModal;
